module.exports = __webpack_public_path__ + "static/media/good_bait.96dee90f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/recordings/good_bait.mp3
// module id = 52
// module chunks = 0